import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="min-h-screen bg-ink-900 text-white flex items-center justify-center">
            <div className="text-center px-6">
                <div className="font-mono-label text-lime-signal mb-4">Error · 404</div>
                <h1 className="font-display uppercase text-6xl md:text-8xl leading-none mb-6">
                    <span className="text-white">Nothing</span>
                    <br />
                    <span className="text-lime-signal">growing here.</span>
                </h1>
                <Link to="/" className="btn-signal inline-flex" data-testid="notfound-home">← Back to site</Link>
            </div>
        </div>
    );
}
